import * as ReqType from '../types/ServerRequests';
import LoginServices from './LoginServices';
import Axios, { AxiosResponse } from 'axios';

/**
 * Cette classe permet la communication entre le backend et le frontend
 * Elle assure l'envois la reception des données entre le backend et frontend
 * Elle permet la creation, modification, et suppression des differentes discipline pour un cours donné
 */
export class DisciplineService {
    private static instance: DisciplineService = new DisciplineService();

    public static getInstance(): DisciplineService {
        return this.instance;
    }

    /**
     * retourne la liste des discipline
     * @returns {Promise<Discipline[]>}
     */
    public getDisciplineList(): Promise<ReqType.Discipline[]> {
        const token = LoginServices.getInstance().getUserToken();
        return Axios.get(
            process.env.REACT_APP_DISCIPLINE_LIST_URL!,
            {
                headers: { 'X-Access-Token': token },
            }
        ).then(
            (response: AxiosResponse<ReqType.Discipline[]>) => {
                return response.data;
            }
        );
    }

    /**
     * retourne la discipline par defaut
     * @returns {Discipline}
     */
    public getDefaultDiscipline(): ReqType.Discipline {
        const retVal: ReqType.Discipline = {
            description: '',
            id: -1,
            intitule: '',
        };
        return (retVal);
    }
}


// WEBPACK FOOTER //
// ./src/services/DisciplineService.tsx